<template>
    <section class="bg-[#f9f9f9] py-20 px-4 relative">
      <div class="max-w-[1140px] mx-auto text-center mb-12">
        <h2 class="text-2xl md:text-4xl font-bold mb-2">
          Veja todos os detalhes de cada plano.
        </h2>
        <p class="text-sm text-gray-500">
          Acesso ROOT completo: liberdade total para instalar, configurar e gerenciar o servidor do seu jeito.
        </p>
      </div>
  
      <div class="overflow-x-auto">
        <div class="w-full max-w-[1140px] mx-auto">
          <table class="w-full text-sm bg-transparent shadow-none rounded-none border-collapse">
            <thead>
              <tr>
                <th class="w-1/4 text-left p-4"></th>
                <th
                  v-for="(plano, index) in planos"
                  :key="plano.id"
                  class="relative text-center pt-10 p-2 border-l border-gray-200 bg-white align-top py-16"
                >
                  <!-- Badge MAIS POPULAR -->
                  <div
                    v-if="index === 1"
                    class="absolute top-2 left-1/2 -translate-x-1/2 bg-yellow-400 text-xs font-bold text-black px-2 py-0.5 rounded shadow"
                  >
                    MAIS POPULAR
                  </div>
  
                  <!-- Conteúdo do card -->
                  <div class="text-[22px] font-bold text-gray-900 mt-6 mb-6">{{ plano.nome }}</div>
                  <div class="text-gray-900 text-xs mb-2 font-light">{{ getDescontoTexto(plano) }}</div>
                  <div class="text-3xl font-extrabold text-cormenubotaoplanos mb-6">
                    R$ {{ calcularDesconto(plano) }}<span class="text-base font-medium">/mês</span>
                  </div>
  
                  <router-link
                    :to="`/assineja-vps-linux-dedicado?planoId=${plano.id}`"
                    class="bg-cormenubotaoplanos text-white px-6 py-2 rounded-full font-semibold hover:brightness-110 transition mb-2 inline-block"
                  >
                    ASSINE JÁ
                  </router-link>
                  <div class="text-xs text-gray-500 mt-8 font-light">
                    Preço na contratação de {{ periodoSelecionadoVpsLinux }} meses
                  </div>
                </th>
              </tr>
            </thead>
  
            <tbody>
              <tr
                v-for="(feature, index) in caracteristicas"
                :key="index"
                class="border-t border-gray-200 bg-white"
              >
                <td class="text-left font-semibold text-gray-700 p-4 bg-white">
                  {{ feature.label }}
                </td>
                <td
                  v-for="(plano, i) in planos"
                  :key="plano.id + '-' + i"
                  class="text-center p-4"
                >
                  <!-- Para checkboxes -->
                  <span v-if="feature.key === 'check'">
                    <span
                      v-if="feature.checks === 'todos' || feature.checks[i]"
                      class="text-green-500 font-bold text-xl"
                    >✓</span>
                    <span v-else class="text-gray-400 font-bold text-xl">✗</span>
                  </span>
  
                  <!-- Para valores personalizados -->
                  <span v-else-if="feature.key === 'custom'">
                    {{ feature.checks[i] }}
                  </span>
  
                  <!-- Padrão -->
                  <span v-else>
                    {{ plano[feature.key] }}{{ feature.suffix ? ' ' + feature.suffix : '' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import axios from '@/services/api'
  import { periodoSelecionadoVpsLinux } from '@/store/periodoStore'
  
  const planos = ref([])
  
  onMounted(async () => {
    try {
      const response = await axios.get('/api/planos/listarativos')
      planos.value = response.data
        .filter(p => p.ativo)
        .filter(p => p.planoTipo === 'VPSLINUX')
        .sort((a, b) => a.ordem - b.ordem)
    } catch (error) {
      console.error('Erro ao buscar planos:', error)
    }
  })
  
  const formatPreco = valor => Number(valor).toFixed(2).replace('.', ',')
  
  const getDescontoPercentual = plano => {
    if (periodoSelecionadoVpsLinux.value === '6') return plano.desconto2 || 0
    if (periodoSelecionadoVpsLinux.value === '12') return plano.desconto3 || 0
    return plano.desconto1 || 0
  }
  
  const calcularDesconto = plano => {
    const desconto = getDescontoPercentual(plano)
    const valorFinal = plano.valor * (1 - desconto / 100)
    return formatPreco(valorFinal)
  }
  
  const getDescontoTexto = plano => {
    const d = getDescontoPercentual(plano)
    return d > 0 ? `${d}% de desconto` : ''
  }
  
  const caracteristicas = [
    { label: 'Processador', key: 'processamento', suffix: 'vCORE @ 2.6 GHz' },
    { label: 'Memória Ram', key: 'ram1' , suffix: ' GB' },
    { label: 'Disco SSD NVMe (Raid 10)', key: 'disco' , suffix: ' GB' },
    { label: 'IP Dedicado', key: 'custom', checks: ['1', '1', '1', '1'] },
    { label: 'Acesso Root', key: 'check', checks: 'todos' },
    { label: 'Sistema Operacional', key: 'custom', checks: ['Linux', 'Linux', 'Linux', 'Linux'] },
    { label: 'Suporte 24h Ticket', key: 'check', checks: 'todos' },
    { label: 'Ajuda via Wiki	', key: 'check', checks: 'todos' },
    { label: 'Link', key: 'custom', checks: ['1 GBits', '1 GBits', '1 GBits', '1 GBits'] },
    { label: 'Tráfego Saída', key: 'custom', checks: ['30 TB', '30 TB', '30 TB','30 TB'] },
    { label: 'Tráfego Entrada', key: 'custom', checks: ['ilimitado', 'ilimitado', 'ilimitado', 'ilimitado'] },
    { label: 'Garantia Uptime', key: 'custom', checks: ['99,99%', '99,99%', '99,99%',  '99,99%'] }


  ]
  

  </script>
  
  <style scoped>
  th,
  td {
    min-width: 160px;
  }
  </style>
  